import { Chip } from "@mui/material";

const OrderStatusTag = ({ status }: { status: string }) => {
  let color: any = "warning";

  if (status === "PENDING") {
    status = "EM ABERTO";
    color = "warning";
  }
  if (status === "PAID") {
    status = "PAGO";
    color = "success";
  }
  if (status === "CANCELED") {
    status = "CANCELADO";
    color = "error";
  }

  return (
    <Chip label={status} color={color} sx={{ color: "#fff", width: "100%" }} />
  );
};

export default OrderStatusTag;
